import {
  DEFAULT_TIER_PICK,
  type TierPickState,
} from "@/components/search/globalSearchConstants";
import {
  DEFAULT_INSTRUMENT_PICK,
  type InstrumentPickState,
} from "@/components/courses/courseCatalogFilters";
import { SkillLevelFilterToolbar } from "@/components/search/skillLevelFilter";
import { useIsMobile } from "@/lib/useDeviceType";
import type { Course } from "@/types";
import React, { useState } from "react";
import { YStack } from "tamagui";

// Instrument pills hidden until courses have real instrument metadata.
// import { FilterPill } from "@/components/search/FilterPill";
// import {
//   COURSE_INSTRUMENT_FILTERS,
//   countCoursesForInstrument,
//   type InstrumentFilterId,
// } from "@/components/courses/courseCatalogFilters";

type Props = {
  courses: Course[];
  tierPick: TierPickState;
  onTierPickChange: React.Dispatch<React.SetStateAction<TierPickState>>;
};

export function CoursesHomeToolbar({
  courses: _courses,
  tierPick,
  onTierPickChange,
}: Props) {
  const isMobile = useIsMobile();
  const [skillMenuOpen, setSkillMenuOpen] = useState(false);

  // const instrumentPills = useMemo(
  //   () =>
  //     COURSE_INSTRUMENT_FILTERS.map((filter) => (
  //       <FilterPill
  //         key={filter.id}
  //         label={filter.label}
  //         count={countCoursesForInstrument(courses, filter.id, tierPick)}
  //         active={instrumentId === filter.id}
  //         onPress={() => onInstrumentChange(filter.id)}
  //       />
  //     )),
  //   [courses, instrumentId, tierPick],
  // );

  return (
    <YStack mb={isMobile ? "$4" : "$5"}>
      <SkillLevelFilterToolbar
        isMobile={isMobile}
        tierPick={tierPick}
        setTierPick={onTierPickChange}
        skillMenuOpen={skillMenuOpen}
        setSkillMenuOpen={setSkillMenuOpen}
      >
        {null}
        {/* {instrumentPills} */}
      </SkillLevelFilterToolbar>
    </YStack>
  );
}

export function useCoursesHomeFilters() {
  const [tierPick, setTierPick] = useState<TierPickState>({ ...DEFAULT_TIER_PICK });
  const [instrumentPick, setInstrumentPick] = useState<InstrumentPickState>({
    ...DEFAULT_INSTRUMENT_PICK,
  });
  return { tierPick, setTierPick, instrumentPick, setInstrumentPick };
}
